import loadable from '@loadable/component';

const ProductTabStatisticsExperiment = loadable(() =>
  import(
    /* webpackChunkName: "ProductTabStatistics" */ './product-tab-statistics'
  )
);

export default ProductTabStatisticsExperiment;
